import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { CommonText, ICommonText } from 'app/constants/schemas/CommonText';
import { Text, IText } from 'app/constants/schemas/Text';
import { Issue, IIssue } from 'app/constants/schemas/Issue';

export interface ISection extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
  };
  associations: {
    commonTitleText: ICommonText | null;
    customTitleText: IText | null;
    commonIntroductionText: ICommonText | null;
    customIntroductionText: IText | null;
    commonTeacherNoteText: ICommonText | null;
    customTeacherNoteText: IText | null;
    issues: IIssue[];
  };
}

export type Section = Entity<ISection>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Section: IEntityType<ISection> = vmClient.defineClass({
  typeName: 'Section',
  version: 8,
  lockable: true,
  persisted: true,

  attributes: {
    cohortId: 'string',
  },
  associations: {
    commonTitleText: {
      type: CommonText,
      shared: true,
    },
    customTitleText: Text,
    commonIntroductionText: {
      type: CommonText,
      shared: true,
    },
    customIntroductionText: Text,
    commonTeacherNoteText: {
      type: CommonText,
      shared: true,
    },
    customTeacherNoteText: Text,
    issues: [Issue],
  },
});
